module.exports = __webpack_public_path__ + "static/media/Slice17@2x.2d1c1d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice17@2x.png
// module id = 1446
// module chunks = 0